import ApiRoutes from "../../../constants/api-routes";
import { ccoInstance } from "../../../service";

export const cooGetAllBlog = async () =>
  ccoInstance.get(`${ApiRoutes.GET_ALL_BLOG}`);

export const cooCreateNewBlog = async (body) =>
  ccoInstance.post(`${ApiRoutes.CREATE_NEW_BLOG}`, body);

export const cooUpdateBlog = async (blogId, body) =>
  ccoInstance.put(`${ApiRoutes.UPDATE_BLOG}/${blogId}`, body);

export const cooDeleteBlog = async (blogId) =>
  ccoInstance.delete(`${ApiRoutes.DELETE_BLOG}/${blogId}`);
